import { Skeleton } from "@/components/ui/skeleton";

export function ChatThreadSkeleton() {
  return (
    <div className="flex min-h-0 flex-1 flex-col gap-4 px-4 py-4" aria-busy="true" aria-label="Loading chat">
      <Skeleton className="ml-auto h-11 w-3/5 rounded-lg" />
      <div className="flex max-w-[95%] flex-col gap-2">
        <Skeleton className="h-3.5 w-full" />
        <Skeleton className="h-3.5 w-5/6" />
        <Skeleton className="h-3.5 w-2/3" />
      </div>
      <Skeleton className="ml-auto h-11 w-2/5 rounded-lg" />
    </div>
  );
}
